/* Load once when real payment markup appears; inspect changes, not the entire page. */
(() => {
  "use strict";
  if (window.gpPaymentWidgetsStarted) return;
  window.gpPaymentWidgetsStarted = true;
  const widgets = [
    {
      selector: "square-placement, [data-afterpay-modal]",
      src: "https://js.squarecdn.com/square-marketplace.js",
    },
    {
      selector: "[data-zm-asset], [zm-asset]",
      src: "https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js",
    },
  ];
  function inspect(root) {
    if (!root.querySelector) return;
    widgets.forEach((widget) => {
      if (
        widget.started ||
        !(root.matches?.(widget.selector) || root.querySelector(widget.selector))
      )
        return;
      widget.started = true;
      if ([...document.scripts].some((script) => script.src === widget.src)) return;
      const script = document.createElement("script");
      script.src = widget.src;
      script.async = true;
      document.head.appendChild(script);
    });
  }
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === "attributes") inspect(record.target);
      else record.addedNodes.forEach(inspect);
    });
    if (widgets.every((widget) => widget.started)) observer.disconnect();
  });
  inspect(document);
  if (!widgets.every((widget) => widget.started))
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-zm-asset", "zm-asset", "data-afterpay-modal"],
    });
})();
